"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMessagesAreLoading = exports.useMessagesMeta = exports.useMessages = exports.useHasInitiallyLoaded = exports.useConversationPartner = exports.useCurrentConversationId = exports.useCurrentConversationGid = exports.useCurrentConversation = exports.useConversation = exports.useConversationsAreLoading = exports.useConversationsMeta = exports.useConversations = exports.useUnreadConversationsCount = exports.useUnreadMessagesCount = exports.useOwnProfileGid = void 0;
const react_redux_1 = require("react-redux");
// General
const useOwnProfileGid = () => react_redux_1.useSelector((store) => store.mailbox.ownProfileGid);
exports.useOwnProfileGid = useOwnProfileGid;
const useUnreadMessagesCount = () => react_redux_1.useSelector((store) => store.mailbox.unreadMessagesCount);
exports.useUnreadMessagesCount = useUnreadMessagesCount;
const useUnreadConversationsCount = () => react_redux_1.useSelector((store) => store.mailbox.unreadConversationsCount);
exports.useUnreadConversationsCount = useUnreadConversationsCount;
// Conversations
const useConversations = () => react_redux_1.useSelector((store) => store.mailbox.conversationData.conversations);
exports.useConversations = useConversations;
const useConversationsMeta = () => react_redux_1.useSelector((store) => store.mailbox.conversationData.meta);
exports.useConversationsMeta = useConversationsMeta;
const useConversationsAreLoading = () => react_redux_1.useSelector((store) => store.mailbox.conversationData.isLoading);
exports.useConversationsAreLoading = useConversationsAreLoading;
const useConversation = (conversationId) => react_redux_1.useSelector((store) => store.mailbox.conversationData.conversations.find((c) => c.id === conversationId));
exports.useConversation = useConversation;
const useCurrentConversation = () => react_redux_1.useSelector((store) => {
    const currentConversationId = store.mailbox.currentConversationId;
    if (!currentConversationId)
        return;
    return store.mailbox.conversationData.conversations.find((c) => c.id === currentConversationId);
});
exports.useCurrentConversation = useCurrentConversation;
const useCurrentConversationGid = () => react_redux_1.useSelector((store) => {
    const currentConversationId = store.mailbox.currentConversationId;
    if (!currentConversationId)
        return;
    const currentConversation = store.mailbox.conversationData.conversations.find((c) => c.id === currentConversationId);
    return currentConversation === null || currentConversation === void 0 ? void 0 : currentConversation.gid;
});
exports.useCurrentConversationGid = useCurrentConversationGid;
const useCurrentConversationId = () => react_redux_1.useSelector((store) => store.mailbox.currentConversationId);
exports.useCurrentConversationId = useCurrentConversationId;
const useConversationPartner = () => {
    const ownProfileGid = exports.useOwnProfileGid();
    const currentConversation = exports.useCurrentConversation();
    if (!ownProfileGid)
        return;
    return currentConversation === null || currentConversation === void 0 ? void 0 : currentConversation.participants.find((p) => p.gid !== ownProfileGid);
};
exports.useConversationPartner = useConversationPartner;
const useHasInitiallyLoaded = () => react_redux_1.useSelector((store) => store.mailbox.conversationData.hasInitiallyLoaded);
exports.useHasInitiallyLoaded = useHasInitiallyLoaded;
// Messages
const useMessages = () => react_redux_1.useSelector((store) => store.mailbox.messageData.messages);
exports.useMessages = useMessages;
const useMessagesMeta = () => react_redux_1.useSelector((store) => store.mailbox.messageData.meta);
exports.useMessagesMeta = useMessagesMeta;
const useMessagesAreLoading = () => react_redux_1.useSelector((store) => store.mailbox.messageData.isLoading);
exports.useMessagesAreLoading = useMessagesAreLoading;
